import { render } from "./ResourceShareUserInput.vue?vue&type=template&id=166fc390"
import script from "./ResourceShareUserInput.vue?vue&type=script&lang=ts"
export * from "./ResourceShareUserInput.vue?vue&type=script&lang=ts"
script.render = render

export default script